import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useAppDispatch } from '../../redux/hooks';
import { setAuthData } from '../../redux/slices/authSlice';
import { UserRole } from '../../redux/types';
import { handleErrorResponse } from '../../utils/handleError';
import { validateOtp } from '../../apis';
import { useNavigate } from 'react-router-dom';

9;

export function useOTPVerification() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [disableSubmit, setDisableSubmit] = useState(false);

  const { mutate, isPending } = useMutation({
    mutationKey: ['patient-verify-otp'],
    mutationFn: ({ email, otp }: { email: string; otp: number }) =>
      validateOtp(email, otp),
    onSuccess: (data) => {
      const token = data.data.token;
      const patientData = data.data.patient;

      const authData = {
        accessToken: token,
        currentUser: {
          id: patientData.id,
          fullName: patientData.full_name,
          hospitalId: patientData?.hospital_id,
          email: patientData.email,
          mobileNumber: patientData.mobile_number,
          role: UserRole.Patient,
          profilePictureUrl: null,
          timezone: null,
        },
      };

      dispatch(setAuthData(authData));
      localStorage.setItem(
        localStorage.AUTH_USER_DATA,
        JSON.stringify(authData)
      );

      navigate('/setup/password', { replace: true });
    },
    onError: (error) => handleErrorResponse(error, 'OTP verification failed'),
    onSettled: () => setDisableSubmit(false),
  });

  const sendOtpRequest = (email: string, otp: number) => {
    setDisableSubmit(true);
    mutate({ email, otp });
  };

  return {
    sendOtpRequest,
    disableSubmit: isPending || disableSubmit,
    isPending,
  };
}
